module.exports = __webpack_public_path__ + "049f2baf022afcdfbce3a857757a8b78.svg";